import React from 'react';
import { FormField } from '@iris-platform/iris-react-ui';
import withStyles from '@material-ui/core/styles/withStyles';
import Panel from '../Panel';


const styles = () => ({
  root: {
    opacity: '1',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    '&:focus-within': {
      border: '1px solid #66afe9',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  btn: {
    marginTop: '20px',
  },
  pageWrapper: {
    transform: 'translateX(50%)',
  },
});

const DmsData = (props) => {
  const { title, formContent, classes } = props;
  return (
    <div className={classes.pageWtrapper}>
      rfsfs
      <Panel
        id="dmsDataPanel"
        title="dms data">
        {formContent.map((item, index) => (
          <FormField
            id="dmsDataField"
            key={index}
            classes={{ root: classes.root }}
            id={item.id}
            label={item.label}
            placeholder={item.placeholder}
          />
        ))}
      </Panel>
    </div>
  );
};

export default withStyles(styles)(DmsData);
